import { Component } from "react";
import NavListItem from "./navListItem.jsx";
import LanguageSwitcher from "./LanguageSwitcher.jsx";
import { useLanguage } from "../../context/LanguageContext.js";
import { en } from "../../content/translations/en.js";
import { zh } from "../../content/translations/zh.js";

// Functional wrapper so class component can use hooks via props
function NavbarWithLang(props) {
  const { lang } = useLanguage();
  const t = lang === "zh" ? zh : en;
  return <NavbarInner {...props} t={t} />;
}

class NavbarInner extends Component {
  constructor(props) {
    super(props);
    this.state = { menuEnabled: false };
  }

  menuClick = (e, ref, route) => {
    if (this.state.menuEnabled) {
      this.setState({ menuEnabled: false });
    }
    try {
      ref.scrollIntoView({ behavior: "smooth" });
    } catch (err) {
      console.warn("Unable to scroll to, ref link is probably broken");
    }
  };

  expendMenu = () => {
    this.setState({ menuEnabled: !this.state.menuEnabled });
  };

  getLinks() {
    const { t } = this.props;
    return [
      { text: t.navbar.home,    route: "home" },
      { text: t.navbar.story,   route: "story" },
      { text: t.navbar.winery,  route: "winery" },
      { text: t.navbar.wines,   route: "wines" },
      { text: t.navbar.contact, route: "contact" },
    ];
  }

  render() {
    const links = this.getLinks();
    return (
      <nav
        id="navbar"
        className="bgt1 bgblur z-999 absolute"
        style={{ position: "fixed", top: 0 }}
      >
        <div className="flex flex-column-m justify-between-l">
          <a href="#home" className="flex-m justify-center-m">
            <h1 className="ma0">
              <img
                className="mr0-m ml0-m h3"
                src={this.props.logo}
                alt="Domaine Michelin - Les Combes Cachées - Organic wineyard in Minervois"
                onClick={(e) =>
                  this.menuClick(e, document.getElementById("root"), "home")
                }
              ></img>
            </h1>
          </a>
          <div
            className="hamburger db dn-ns self-center pa3"
            style={{ marginLeft: "auto" }}
            id="expandmenu"
            onClick={this.expendMenu}
          >
            <svg
              width="2em"
              height="2em"
              viewBox="0 0 16 16"
              className="bi bi-three-dots-vertical pointer"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                fill="white"
                d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
              />
            </svg>
          </div>

          {/*================= DESKTOP MENU =================*/}
          <ul className="dn mt2-m mb3-m list justify-around tc flex-ns pa1 mr3 self-center-l" style={{ alignItems: "center" }}>
            {links.reduce((acc, link) => {
              acc.push(
                <NavListItem
                  key={acc.length}
                  text={link.text}
                  route={link.route}
                  refprop={this.props.refs[acc.length]}
                  active={this.props.active}
                  callback={this.menuClick}
                  className="tc1 pointer link dim f4 ma3-l mb0-l mt0-l"
                />
              );
              return acc;
            }, [])}
            <li style={{ listStyle: "none", marginLeft: "1rem" }}>
              <LanguageSwitcher />
            </li>
          </ul>
        </div>

        {/*================= MOBILE MENU =================*/}
        {this.state.menuEnabled ? (
          <ul className="dn-ns list mb0 justify-around vh-50 tc v-mid flex flex-column flex-row-ns">
            {links.reduce((acc, link) => {
              acc.push(
                <NavListItem
                  key={acc.length}
                  text={link.text}
                  route={link.route}
                  refprop={this.props.refs[acc.length]}
                  active={this.props.active}
                  callback={this.menuClick}
                  className="tc1 pointer link dim f3"
                />
              );
              return acc;
            }, [])}
            <li style={{ listStyle: "none", margin: "1rem auto" }}>
              <LanguageSwitcher />
            </li>
          </ul>
        ) : null}
      </nav>
    );
  }
}

export default NavbarWithLang;
